import { render } from "./SavedStyleSelector.vue?vue&type=template&id=23851650"
import script from "./SavedStyleSelector.vue?vue&type=script&lang=js"
export * from "./SavedStyleSelector.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__